import html2pdf from "html2pdf.js"

type PrintableReturn = {
  generatePDF: ({ elementId, fileName }: { elementId: string; fileName: string }) => Promise<void>
}

export const usePrintable = ({ format = "a4", margin = 0.3 } = {}): PrintableReturn => {
  const generatePDF = async ({ elementId, fileName }: { elementId: string; fileName: string }) => {
    const element = document.getElementById(elementId) as HTMLElement

    if (element) {
      const temp = document.createElement("div")
      temp.innerHTML = element.innerHTML

      const style = document.createElement("style")

      style.textContent = `
    * {
      font-family: "Inter", sans-serif !important;
    }`

      temp.appendChild(style)

      document.body.appendChild(temp)

      await html2pdf()
        .set({
          margin,
          filename: `${fileName}.pdf`,
          image: { type: "jpeg", quality: 1 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: {
            unit: "in",
            format,
            orientation: "portrait",
            useCORS: true,
          },
        })
        .from(temp)
        .save()

      document.body.removeChild(temp)
    }
  }

  return { generatePDF }
}
